import React, { useCallback, useMemo, useRef, } from "react";
import { useControl, useControlReducer } from "../../../controlContext";
import { Form } from "react-bootstrap";
import { Remarkable } from 'remarkable'
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/markdown.css'
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { useDynamicTextAreaHeight } from "../utils/hooks";
import { OpenChatButton } from '../../../../revised_components/OpenChatButton';
import { ChatWrapper } from '../../../../revised_components/ChatWrapper';

export function MarkdownControl({ label, placeholder, name, idx, displaySettings = {}, objectMetadata }) {
  const { [idx]: block } = useControl()
  const { [name]: value } = block
  // const [!readOnly, setEdit] = useState(!value)
  const { settings: { readOnly } } = useControlHeaderContext()
  const controlReducer = useControlReducer()
  const [textContainerRef, textareaRef] = useDynamicTextAreaHeight(readOnly, value)
  let reportId = useMemo(() => objectMetadata?._id, [objectMetadata]);

  let timeout_id = useRef()
  const onChange = useCallback((val) => {
    clearTimeout(timeout_id.current)
    timeout_id.current = setTimeout(() => {
      controlReducer({ type: 'changed', name, idx, update: {[name]:  val}  })
    }, 1000)
  }, [controlReducer, name, idx])

  // function focustextArea(){textareaRef.current.focus()}
  const renderedMardownComponent = useMemo(() => (!readOnly ? false : { __html: new Remarkable({ breaks: true }).render(value) }), [value, readOnly])

  let control = useMemo(() => !readOnly ? (
    <div ref={textContainerRef} className="report-markdown-text-container">
       {/*<ChatWrapper
          textSourceRef={textareaRef}
          fieldName={name}
          reportId={reportId}
          blockId={block._id}
          onChange={onChange}
          onChatClose={() => {}}
        >*/}
       <Form.Control
        ref={textareaRef}
        as="textarea"
        placeholder={placeholder || label}
        className={displaySettings.className + ' joy-like-markdown'}
        defaultValue={value}
        onChange={(evt) => onChange(evt.target.value)}
      />
      {/*</ChatWrapper>*/}
    </div>
  ) : (
    <div
      ref={textContainerRef}
      className={`${displaySettings.className} report-markdown-text-container`}
      dangerouslySetInnerHTML={renderedMardownComponent}>
    </div>
  ), [
    onChange,
    readOnly,
    textContainerRef,
    textareaRef,
    placeholder,
    label,
    displaySettings,
    value,
    renderedMardownComponent
  ])

  let labelProps = useMemo(() => displaySettings.labelProps ? displaySettings.labelProps : {}, [displaySettings])

  return label ? (
    <div>
      <Form.Label {...labelProps}>{label}</Form.Label>
      {control}
    </div>
  ) : control
}
